import { requestGet, requestPost } from '@/common/request';

export default {
  // 查询频道活动列表
  async channelActivityList(query) {
    return await requestGet('/channelActivity/list', query);
  },
  // 创建频道活动
  async channelActivityAdd(query) {
    return await requestPost('/channelActivity/add', query);
  },
  // 查询频道活动
  async channelActivityGetChannel(query) {
    return await requestGet('/channelActivity/getChannel', query);
  },
  // 判断当前登陆erp的角色
  async channelMemberErpInfo(query) {
    return await requestGet('/channelMember/erpInfo', query);
  },

  // 频道删除
  async channelActivityDeleteChannel(query) {
    return await requestGet('/channelActivity/deleteChannel', query);
  },

  // 频道新增
  async channelActivityAddChannel(query) {
    return await requestPost('/channelActivity/addChannel', query);
  },

  // 频道更新
  async channelActivityUpdateChannel(query) {
    return await requestPost('/channelActivity/updateChannel', query);
  },

  // 查询人员配置列表
  async channelMemberMemberList(query) {
    return await requestGet('/channelMember/memberList', query);
  },

  // 频道成员添加
  async channelMemberAddMembers(query) {
    return await requestPost('/channelMember/addMembers', query);
  },

  // 频道成员删除
  async channelMemberDeleteMember(query) {
    return await requestGet('/channelMember/deleteMember', query);
  },

  // 校验erp有效性
  async commonServiceVerifyErps(query) {
    return await requestGet('/commonService/verifyErps', query);
  },

  // 组长转让
  async channelMemberTransferLeader(query) {
    return await requestGet('/channelMember/transferLeader', query);
  },
  // 查询秒杀、闪购模块列表
  async channelActivityQueryHomeModuleList(query) {
    return await requestGet('/channelActivity/queryHomeModuleList', query);
  },
  // 频道分析看板白名单 - 新增
  async industryChannelAddWhite(query) {
    return await requestPost('/industryChannel/addWhite', query);
  },
  // 频道分析看板白名单 - 删除
  async industryChannelDelWhite(query) {
    return await requestGet('/industryChannel/delWhite', query);
  },
  // 频道分析看板白名单 - 列表
  async industryChannelListWhite(query) {
    return await requestGet('/industryChannel/listWhite', query);
  },
};
